import { theme } from '../../ThemeContext/ThemeObject';

export const classes = {
  pageContainer: {
    fontFamily: theme.typography.fontFamily,
    backgroundColor: '#FFFFFF',
    padding: '40px'
  },
  pageHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '0px 16px 26px 16px',
    '& h1': {
      fontFamily: 'Source Sans Pro',
      fontWeight: 'bold',
      fontSize: '38px',
      color: '#666666',
      marginTop: '0'
    }
  },
  tabsContainer: {
    borderBottom: 1,
    borderColor: '#EEEEEE',
    margin: '25px 0'
  },
  tabs: {
    '& button': {
      fontFamily: 'Source Sans Pro',
      fontSize: '18px',
      letterSpacing: '0',
      color: '#939393',
      textTransform: 'none',
      minWidth: 'unset',
      '&:hover': {
        color: '#737373'
      },
      '&:focus': {
        outline: 'none'
      }
    },
    '& button.Mui-selected': {
      fontWeight: '600',
      color: '#084D6D'
    }
  },
  tabIndicator: {
    backgroundColor: '#5BC4BF',
    margin: '0 16px'
  },
  screeningBadge: {
    textAlign: 'center',
    fontSize: '13px',
    fontWeight: 'bold',
    borderRadius: '6px',
    textTransform: 'uppercase',
    padding: '8px 24px',
    width: '150px',
    height: '35px',
    color: '#8CCF95',
    backgroundColor: 'RGBA(140, 207, 149, 0.12)'
  },
  matchingBadge: {
    textAlign: 'center',
    fontSize: '13px',
    fontWeight: 'bold',
    borderRadius: '6px',
    textTransform: 'uppercase',
    padding: '8px 24px',
    width: '150px',
    height: '35px',
    color: '#E6A052',
    backgroundColor: 'RGBA(230, 160, 82, 0.12)'
  }
}; 
